import { readContract } from '@wagmi/core';

import { Address } from 'viem';

import { LAUNCHPAD_SALE_POOL_TYPE } from '@api';

import { wagmiConfig, WagmiConfigChain } from '@shared/common/providers/Web3Provider/wagmi';
import {
  DEFAULT_TARGET_CHAIN,
  LAST_FCFS_CONTRACT_VERSION,
  LAST_PRO_RATA_CONTRACT_VERSION,
  LAUNCHPAD_DEPOSIT_CONTRACTS,
} from '@shared/constants';

type LaunchpadAbiProps = {
  depositContractAddress?: string;
  chainId?: WagmiConfigChain['id'];
  isProRata?: boolean;
};

const getContractVersion = ({
  depositContractAddress,
  chainId = DEFAULT_TARGET_CHAIN.id,
  isProRata = false,
}: LaunchpadAbiProps): Promise<string> => {
  return readContract(wagmiConfig, {
    abi: isProRata
      ? LAUNCHPAD_DEPOSIT_CONTRACTS.PRO_RATA[LAST_PRO_RATA_CONTRACT_VERSION].abi
      : LAUNCHPAD_DEPOSIT_CONTRACTS.FCFS[LAST_FCFS_CONTRACT_VERSION].abi,
    chainId,
    address: depositContractAddress as Address,
    functionName: 'getContractVersion',
  });
};

export const getMajorVersion = async (props: LaunchpadAbiProps) => {
  const version = await getContractVersion(props);
  const majorVersion = version.split('.')[0] ?? '0';
  return Number(majorVersion);
};

export const getLaunchpadAbi = async (props: LaunchpadAbiProps) => {
  const majorVersion = await getMajorVersion(props);
  const contractType = props.isProRata
    ? LAUNCHPAD_SALE_POOL_TYPE.PRO_RATA
    : LAUNCHPAD_SALE_POOL_TYPE.FCFS;

  const contract = LAUNCHPAD_DEPOSIT_CONTRACTS[contractType][majorVersion];

  return contract.abi;
};
